import { compose } from 'recompose'
import HTTP_STATUS from 'utils/statusCode'
import { removeToken } from 'utils/token'
import browserHistory from 'utils/browserHistory'

const redirect = path => () => window.location.replace(path)

const redirectRouter = path => () => {
  browserHistory.push(path)
}

const httpStatusHandlers = {}

httpStatusHandlers[HTTP_STATUS.UNAUTHORIZED] = compose(removeToken, redirect('/autenticacao'))

httpStatusHandlers[HTTP_STATUS.INTERNAL_SERVER_ERROR] = redirectRouter('/erro-de-servico')

httpStatusHandlers[HTTP_STATUS.UNSUPPORTED_MEDIA_TYPE] = redirectRouter('/erro-de-servico')

const handleHttpStatus = status => (httpStatusHandlers[status] || (() => null))()

export default handleHttpStatus
